import { ActionTitle } from "@/components/actionTitle/ActionTitle";
import { InstallationQuotations } from "@/features/orders/installationQuotation/InstallationQuotations";
import { InstallationServiceChecker } from "@/features/orders/installationQuotation/InstallationServiceChecker";
import { useActiveProject } from "@/features/project/ActiveProject";
import { RECOMMENDED_ACTION_IDS } from "@/features/project/projectAI/utils";
import { Accordion, AccordionItem } from "@repo/skapa";
import { t } from "@repo/translation";
import { PaddedContainer, SectionContainer, useCustomer } from "@repo/ui";

export const InstallationQuotationSection = ({
  editable,
}: {
  editable: boolean;
}) => {
  const { opportunity } = useActiveProject();
  const { customer } = useCustomer(opportunity?.id);
  const noOfInstallationQuotations =
    opportunity?.installationQuotes?.installationQuotationInfo?.length || 0;

  if (!opportunity) {
    return null;
  }

  const requestedQuoteExists =
    opportunity.installationQuotes?.installationQuotationInfo?.some(
      (item) => item.status?.toLowerCase() === "requested"
    ) || false;

  const addressDataMissing = !customer?.streetAddress1?.length;

  return (
    <PaddedContainer id={RECOMMENDED_ACTION_IDS.INSTALLATION_QUOTATION_SECTION}>
      <SectionContainer>
        <ActionTitle
          title={`${noOfInstallationQuotations > 1 ? t("label.installation_quotations") : t("label.installation_quotation")} (${noOfInstallationQuotations})`}
        />
        <InstallationQuotations editable={editable} />
        {!requestedQuoteExists && (
          <Accordion>
            <AccordionItem
              id="installation-sevice-checker"
              title={t("label.installation_service_checker_title")}
              open={false}
            >
              <InstallationServiceChecker
                projectId={opportunity.id}
                customerPostalCode={customer?.postalCode}
                addressDataMissing={addressDataMissing}
              />
            </AccordionItem>
          </Accordion>
        )}
      </SectionContainer>
    </PaddedContainer>
  );
};
